module.exports = __webpack_public_path__ + "common/icon-external-link-266d44657af638e930ccc19707130d06.svg";